import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'
import { UpdateContentForm } from '../_components/content-forms.component'
import { EContentType } from '../_components/content.type'
import { useEffect, useState } from 'react'
import { ProjectService } from 'src/services/project.service'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useQuery } from '@tanstack/react-query'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useParams } from 'react-router-dom'

export default function UpdateContentPage() {
  const { contentId: contentIdParam } = useParams<{ contentId: string }>()
  const contentId = Number(contentIdParam)
  const { project } = useCurrentProject()
  const { t } = useTranslation()

  const {
    isLoading,
    error,
    data: content,
  } = useQuery({
    queryKey: ['content', project.id, contentId],
    queryFn: () => ProjectService.getSelfConfigurationContent(project.id, contentId),
  })

  const [contentType, setContentType] = useState<EContentType | null>(null)

  useEffect(() => {
    content && setContentType(content.type)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content?.id])

  if (error) return <ErrorQueryHandler error={error} />
  if (!contentType || !content || isLoading) return <div className="loading" />

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.contents.update-content')}
      className="c-overflow-visible"
    >
      <UpdateContentForm content={content} />
    </ConfigurationHeaderWrapper>
  )
}
